var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88086 6.03711C6.08594 6.24219 6.37305 6.24219 6.57812 6.03711L11.3359 1.23828C11.541 1.0332 11.541 0.705078 11.3359 0.541016L11.0488 0.253906C10.8438 0.0488281 10.5566 0.0488281 10.3516 0.253906L6.25 4.4375L2.10742 0.212891C1.90234 0.0488281 1.61523 0.0488281 1.41016 0.212891L1.12305 0.541016C0.917969 0.705078 0.917969 1.0332 1.12305 1.23828L5.88086 6.03711Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.34bb1a4554b1b484667095d4bd9a3acd.svg";
export { ForwardRef as ReactComponent };